var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8123 5.06238C13.8123 2.41555 11.6466 0.25 8.99988 0.25C6.35313 0.25 4.1875 2.41563 4.1875 5.06238C4.1875 7.70914 6.35313 9.87476 8.99988 9.87476C11.6466 9.87476 13.8123 7.70914 13.8123 5.06238V5.06238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.903 10.8809C10.2906 11.0778 9.65614 11.1872 8.99989 11.1872C8.34364 11.1872 7.70921 11.0778 7.09676 10.8809C5.17181 10.2465 3.028 10.7715 1.75938 12.3247C0.818651 13.4841 0.25 14.9716 0.25 16.5685C0.25 17.4655 0.971876 18.1874 1.8688 18.1874H16.1312C17.0281 18.1874 17.75 17.4655 17.75 16.5685C17.75 14.9717 17.1812 13.4842 16.2406 12.3247C14.9499 10.7716 12.828 10.2466 10.9029 10.8809H10.903Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminProfileIcon);
export default __webpack_public_path__ + "static/media/admin-profile-icon.6c729bca32a94bb8fd8bee339ab34c57.svg";
export { ForwardRef as ReactComponent };